import { bb } from "$json";
/* language-auto-switch:
 *
 * This plugin will look at the
 * model language and swicth to
 * the correct layer based on a
 * provided set of layers.
 *
 * NB Dependencies:
 * For each layer using this plugin,
 * there needs to be an arbitrary
 * object in the main conf.json
 * mapping the languages to their
 * respective layers. The base-layer
 * should always point to the primary
 * language layer, usually bb.html
 *
 * e.g.:
"arbitrary": {
 "languageLayers": {
   "base-layer": "bb.html",
   "en-us": "en.html",
   "nl-nl": "bb.html"
 }
},
 * Author: Tim Bauwens
 * Copyright 2017 Berkeley Bridge
 *
 */

(function ($, document) {
  $(document).on("bb:postHandleData", function (event, data) {
    if (data && data.groups) {
      var modellanguage = data.modellanguage;
      var currentLayerlanguage = window.location.pathname
        .split("/")
        .slice(-1)[0];
      if (currentLayerlanguage === "")
        currentLayerlanguage = bb.conf.arbitrary.languageLayers["base-layer"];
      var desiredLayerlanguage =
        bb.conf.arbitrary.languageLayers[modellanguage];
      if (
        desiredLayerlanguage &&
        desiredLayerlanguage != currentLayerlanguage
      ) {
        window.location.assign(desiredLayerlanguage);
      }
    }
  });
})(jQuery, document);
